/**
 * Was meldet Jev am Ende DIESES Zugs über das Mikro? (07.10.2026, Ticket 3048)
 *
 * Der Server sagt es am Zugende mit dem Ereignis `mikro` (vor `done`):
 * „zu“, „kurz“ oder „offen“ samt Grund und Jevs Wert
 * (shared/mikro-nach-antwort.ts, server/jev-abschluss.ts `jevMikroStufe`).
 * Hier steht nur der Merker; was daraus folgt, entscheidet `mikroNachAntwort`
 * am Vorlese-Ende — und nur in der Stufe „Jev entscheidet“.
 *
 * ⚠️ EIN Besitzer: nur diese Datei schreibt ihn. Er gilt für DIESEN Zug —
 *    eroeffneZug (app.ts) setzt ihn zurück, der Hörer am Vorlese-Ende löst
 *    ihn einmal ein. Ein abgebrochenes Vorlesen meldet kein Ende; ohne den
 *    Rücksatz beim nächsten Zug entschiede die alte Meldung über dessen Mikro.
 * ⚠️ Kommt keine Meldung (älterer Server, anderes Konto, Chat-Weg), bleibt er
 *    `null` — das heißt „offen wie bisher“.
 */
import { jevMikroAus, type JevMikroMeldung } from "../../shared/mikro-nach-antwort.js";

let meldung: JevMikroMeldung | null = null;

/** Ein neuer Zug beginnt ohne Meldung. */
export function zugOhneJevMikro(): void {
  meldung = null;
}

/** Das Zugende meldet Jevs Stufe (roh, wie sie im Ereignis steht). */
export function merkeJevMikro(roh: unknown): void {
  meldung = jevMikroAus(roh);
}

/** Nur ansehen, nichts löschen (Mikro-Vorstart, mikro-vorstart.ts): was hat Jev gemeldet? */
export function jevMikroAnsehen(): JevMikroMeldung | null {
  return meldung;
}

/** Am Vorlese-Ende: was hat Jev gemeldet? Einmal gelesen, dann gelöscht. */
export function jevMikroEinloesen(): JevMikroMeldung | null {
  const war = meldung;
  meldung = null;
  return war;
}
